<form class="filter table-filter" [formGroup]="searchForm">
  <mat-form-field class="form" subscriptSizing="dynamic">
    <mat-chip-grid #assistChips>
      @for (assist of activeAssists$ | async; track assist) {
        <mat-chip-row (removed)="onRemoveAssist(assist.id)">
          {{ assist.description }}
          <button matChipRemove>
            <app-icon icon="delete"></app-icon>
          </button>
        </mat-chip-row>
      }
      <input matInput class="form"
        i18n-placeholder
        placeholder="Type here to filter shipments..."
        [matChipInputFor]="assistChips"
        [matAutocomplete]="filterAssist"
        type="text" formControlName="terms"
        #termsInput
        >
    </mat-chip-grid>
    <mat-autocomplete #filterAssist (optionSelected)="onAssistSelection($event.option.value)">
      @for (assist of offeredAssists$ | async; track assist) {
        <mat-option [value]="assist">
          {{ assist.description }}
          @if (assist.category == categoryShipmentDate) {
            <span class="category accent-contrast color accent-background-50" i18n>
                        Shipment Date
                    </span>
          }
          @if (assist.category == categoryShipper) {
            <span class="category accent-contrast color accent-background-100" i18n>
                        Shipper
                    </span>
          }
          @if (assist.category == categoryDestination) {
            <span class="category accent-contrast color accent-background-200" i18n>
                        Destination
                    </span>
          }
          @if (assist.category == categoryStatus) {
            <span class="category accent-contrast color accent-background-300" i18n>
                        Shipment Status
                    </span>
          }
          @if (assist.category == categoryService) {
            <span class="category accent-contrast color accent-background" i18n>
                        Courier Service
                    </span>
          }
          @if (assist.category == categoryBatch) {
            <span class="category accent-contrast color accent-background-400" i18n>
                        Batch
                    </span>
          }
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
